<app-header-one></app-header-one>
<app-about></app-about>
<app-service></app-service>
<app-about-us></app-about-us>
<app-faqs></app-faqs>
<app-portfolio></app-portfolio>
<app-team></app-team>
<app-skills></app-skills>
<app-footer
  [layout]="classname"
  [logo]="ftlogo"
  [shapeclass]="ftshapeclass"
  [shape2class]="ftshape2class"
></app-footer>
